import { render, staticRenderFns } from "./pageHeaderModule.vue?vue&type=template&id=76794953&scoped=true&"
import script from "./pageHeaderModule.vue?vue&type=script&lang=js&"
export * from "./pageHeaderModule.vue?vue&type=script&lang=js&"
import style0 from "./pageHeaderModule.vue?vue&type=style&index=0&id=76794953&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76794953",
  null
  
)

export default component.exports